import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import companies from './sidebarItems/companies';
import franchises from './sidebarItems/franchises';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import kanban from './sidebarItems/kanban';
import primaryMenu from './sidebarItems/primaryMenu';
import automations from './sidebarItems/automations';

// `context` é opcional: quem não o passa recebe os rótulos genéricos, que é o
// comportamento de antes. Só o menu de franqueados o consome hoje, para dizer "Meus
// Franqueados" a quem enxerga apenas as próprias franquias.
export const getSidebarItems = (accountId, context = {}) => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    companies(accountId),
    franchises(accountId, context),
    reports(accountId),
    campaigns(accountId),
    automations(accountId),
    settings(accountId),
    notifications(accountId),
    kanban(accountId),
  ],
});
